import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class SalesforceService {
  async getAccountsHubSpot() {
    return await axios
      .get(API_URL + "/SalesForce/GetAccountsHubspot")
      .then((response) => {
        if (response.data.length > 0) {
          store.commit("salesForce/updateAccounts", response.data);
          store.commit("salesForce/setDefaultCustomerItem");
          store.commit("salesForce/resetSelectedNewsPerCustomer");
          store.commit("salesForce/updateNewsForCurrentCustomer");
          store.commit("salesForce/resetSelectedSchemesPerCustomer");
          store.commit("salesForce/updateSchemesForCurrentCustomer");
        }
      });
  }

  async postNewsSelection(data, schemesData, last) {
    return await axios
      .post(API_URL + "/SalesForce/PostNewsSelection", {
        itemsList: data,
        schemeItemsList: schemesData,
        last: last,
      })
      .catch((error) => {
        if (error) alert("Er ging iets mis!");
      });
  }
}

export default new SalesforceService();

